import Constants from '../utils/consts';
import Utils from '../utils/utils';
import Cookies from 'universal-cookie';

var db = new Cookies().get('db', {path: '/' });
var http = require('follow-redirects').https;
var fs = require('fs');
var qs = require('querystring');


export default async function updateCorso(uname, token, id, name, dateStart, dateEnd, divisione_fatturato, visibleStudent, visibleTeacher, anno_accademico) {
    return new Promise(function (resolve, reject) {

        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': Constants.apisFolder + 'updateCorso.php',
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
            resolve();
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });

        var postData = qs.stringify({
        'token': token,
        'uname': uname,
        'id': id,
        'name': Utils.escapeString(name),
        'dateStart': dateStart,
        'dateEnd': dateEnd,
        'divisione_fatturato': divisione_fatturato,
        'visibleStudent': visibleStudent,
        'visibleTeacher': visibleTeacher,
        'anno_accademico': anno_accademico,
        'db_name': db
        });

        req.write(postData);

        req.end();

        
    });
}
